import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Suppress noisy console output when running outside localhost — keeps logs
// visible during local development and in browser devtools while serving
// against `ng serve`, but silences `log`/`info`/`debug` once the app is
// deployed to dev/prod hosts. `warn` and `error` are preserved so production
// diagnostics still surface.
const isLocalhost = location.hostname === 'localhost' || location.hostname === '127.0.0.1';
if (!isLocalhost) {
  const noop = (): void => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
